// extracted by mini-css-extract-plugin
export var btnActive = "photoCredits-module--btnActive--a215f";
export var pictureCredits = "photoCredits-module--pictureCredits--9db8b";
export var pictureCreditsButton = "photoCredits-module--pictureCreditsButton--f58d7";
export var show = "photoCredits-module--show--346cc";